<!--
 * @Descripttion: 
 * @version: 
 * @Author: lxh
 * @Date: 2022-07-28 18:16:28
-->
<template>
  <a-config-provider :locale="zh_CN">
    <router-view />
  </a-config-provider>
</template>

<script>
// import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import zh_CN from "ant-design-vue/es/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
dayjs.locale("zh-cn");
import { defineComponent } from "vue";
export default defineComponent({
  setup() {
    return {
      zh_CN,
    };
  },
});
</script>

<style lang="less">
@import "./less/base.less";
</style>
